import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import ConfirmationMessage from '../../../components/confirmation-message/index';
import { Warning } from '../../../helpers/icon-dictionary';
import messages from '../messages';
import withModal from '../../with-modal';

const ExtendResultFailure = (props) => {
    const { intl,
        handleOnClick
    } = props;

    return (<ConfirmationMessage
        handleOnCloseModal={handleOnClick}
        icon={Warning}
        title={intl.formatMessage(messages.failureTitle)}>
        {intl.formatMessage(messages.failureMessage)}
    </ConfirmationMessage>);
};

ExtendResultFailure.propTypes = {
    handleOnClick: PropTypes.func,
    intl: intlShape.isRequired
};

export default withModal('isActive')(injectIntl(ExtendResultFailure));



// WEBPACK FOOTER //
// ./app/components/extend-result/modals/failure.js